import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $isIframe: boolean }>`
	padding-top: 100px;

	${({ $isIframe }) =>
		$isIframe &&
		css`
			margin-top: 56px;
		`}

	@media (max-width: 992px) {
		padding-top: 10px;
	}
`;

export const Content = styled.div`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	position: relative;
	width: 100%;
	z-index: 2;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;

export const ContentLeft = styled.div`
	max-width: 603px;
	width: 100%;
`;

export const Title = styled.h2`
	font-size: 48px;
	font-weight: 700;
	line-height: 59px;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 20px;

	@media (max-width: 992px) {
		font-size: 32px;
		line-height: 38px;
	}
`;

export const Text = styled.p`
	font-size: 18px;
	line-height: 25px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
	margin: 0;

	@media (max-width: 992px) {
		font-size: 16px;
		line-height: 20px;
	}
`;

export const ButtonRow = styled.div`
	margin-top: 20px;
	display: flex;
	gap: 16px;
`;

export const IntroPic = styled.img`
	max-width: 580px;
	width: 100%;
	height: auto;
	object-fit: contain;
	flex-shrink: 0;
`;
